import React from "react";
import { MessageSquarePlus } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * "Cite in Thread" button — stashes a ThreadAttachedRef in sessionStorage and
 * jumps to /threads so the composer pre-attaches this artifact. Universal
 * across all three Vault categories:
 *   - kind="dossier",     ref=slug,  title, url=/dossier/:slug
 *   - kind="ai_dossier",  ref=id,    title, url=/ai-dossier/:id
 *   - kind="connection",  ref=id,    title, url=/connection/:id
 */
export default function CiteInThreadButton({ kind, ref: artifactRef, title, url, testid = "cite-in-thread", size = "sm" }) {
  const nav = useNavigate();

  const onClick = () => {
    try {
      sessionStorage.setItem("vault.threads.prefill_ref", JSON.stringify({
        type: kind, id: artifactRef, title, url,
      }));
    } catch { /* ignore */ }
    nav("/threads");
  };

  const cls = "inline-flex items-center gap-2 font-mono uppercase tracking-[0.2em] border border-[#ffd60a]/40 text-[#ffd60a] hover:bg-[#ffd60a]/10 transition-colors " +
    (size === "sm" ? "px-3 py-1.5 text-[10px]" : "px-4 py-2 text-[11px]");

  return (
    <button type="button" onClick={onClick}
      data-testid={testid}
      title="Open a new thread with this artifact attached as a receipt"
      className={cls}>
      <MessageSquarePlus size={11} /> CITE IN THREAD
    </button>
  );
}
